<ng-container *ngIf="participant$ | async as participant">
  <app-table-suivis
    [source]="suivis$ | async"
    (add)="onAdd($event, participant)"
    (update)="onUpdate($event, participant)"
    (delete)="onDelete($event, participant)"
    (deleteAll)="onDeleteAll(participant)"
  ></app-table-suivis>
</ng-container>
